import React from 'react';

export type BgisModalBodyProps = {
  children?: React.ReactNode;
};

const BgisModalBody  : React.FC<BgisModalBodyProps> = ({ children }: BgisModalBodyProps) => {

    return (
            <div className="bgis-modal-body">
                {children}
             </div>
);

}

export {BgisModalBody }